import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BaseService } from '../../../base.service';
import { UserModel, UsersService } from '../users/users.service';
import { ToastService } from '../../../toast.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss']
})
export class PartnersComponent implements OnInit {

  constructor(
    public router: Router,
    public UsersService: UsersService,
    public baseService: BaseService,
    public ToastService: ToastService
  ) {}
  showPassword: boolean = false;
  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
  UserType = 4 ;
  msg: any;
  ModalVisible: boolean = false;
  customStylesValidated: boolean = false;
  Loading: boolean = false;
  ButtonLoading: boolean = false;
  EditMode: boolean = false;
  details_visible = Object.create({});
  toggleDetails(item: any) {
    this.details_visible[item] = !this.details_visible[item];
  }
  
  validatePhoneNumberInput(event: KeyboardEvent): void {
    const allowedChars = /[0-9\s()+-]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (!allowedChars.test(inputChar)) {
      event.preventDefault();
    }
  }

  @ViewChild('UserDetailsForm') UserDetailsForm: any;
  @ViewChild('imageField') imageField: any;
  toggleModal() {
    
    if (this.ModalVisible) {
      this.customStylesValidated = false;
      this.UsersService.UserData = new UserModel();
      this.EditMode = false;
    }
    this.ModalVisible = !this.ModalVisible;
  }
  fileSelected: File | undefined;
  imageSrc: string | ArrayBuffer | undefined;
  onFileSelected(event: any) {
    console.log(event.target.files[0]);
    const maxAllowedSize = 2 * 1024 * 1024;
    if (event.target.files[0].size > maxAllowedSize) {
      alert('Only 2 MB size is allowed!');
      event.target.value = '';
    }
    const file: File = event.target.files[0];
    this.fileSelected = file;
    this.UsersService.UserData.file = file;
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imageSrc = e.target.result;
      };
      reader.readAsDataURL(file);
    }
    console.log(
      '🚀 > PromotionsComponent > onFileSelected > this.fileSelected:',
      this.fileSelected
    );
  }
  UsersData: any;
  ProductsData: any;
  UsersColumns: any = [
    
    {
      key: 'picture',
      label: 'Image',

    },
    // {
    //   key: 'userName',
    //   label: 'User Name',
    // },
    {
      key: 'userDisplayName',
      label: 'Name',
    },
    {
      key: 'emailAddress',
      label: 'Email',
    },
    // {
    //   key: 'mobilePhoneNumber',
    //   label: 'Phone Number',
    // },
    // {
    //   key: 'address',
    //   label: 'Address',
    // },
    {
      key: 'isApproved',
      label: 'Approved',
    },
    {
      key: 'isActive',
      label: 'Status',
    },
    // {
    //   key: 'Actions',
    //   label: '',
    //   _style: { width: '5%' },
    //   filter: false,
    //   sorter: false,
    // },
  ];
  
  ngOnInit(): void {
    if (!this.baseService.CheckPermissions(this.router.url)) {
      this.router.navigate(['/dashboard']);
    }
    
    this.getUsers();
  }

  //get all Users
  getUsers() {
    this.Loading = true;
    this.UsersService.getUsers().subscribe({
      next: (res: any) => {
        this.UsersData = res.data.filter((item: any) => item.userType_Id == this.UserType);
        this.Loading = false;
      },
      error: (error) => {
        console.error(error);
        this.Loading = false;
      },
    });
  }


  AddUserCall(UserDetailsForm: any, UserData: any) {
    console.log("🚀 > UsersComponent > onSubmitUserForm > UserData:", UserData)
    this.ButtonLoading = true;
    this.customStylesValidated = true;
    if (UserDetailsForm.invalid) {
      this.ButtonLoading = false;
      return;
    }
    // UserData.createdOnUTC = new Date().toISOString();
    // UserData.updatedOnUTC = new Date().toISOString();
    UserData.createdBy = JSON.parse(localStorage.getItem('UserInfo')?.toString() || '{}')?.id;
    UserData.aspUserID = '.';
    UserData.isEmailVerified = false;
    UserData.isMobilePhoneVerified = false;
    UserData.partner_Id = JSON.parse(localStorage.getItem('UserInfo')?.toString() || '{}')?.partner_Id;
    UserData.userType_Id = this.UserType;
    UserData.password = this.UsersService.generateRandomPassword(8);
    UserData.userName = UserData.emailAddress;
    UserData.isActive = true;
    UserData.isApproved = true;
    UserData.mobilePhoneNumber ='.';
    UserData.address ='.';
    UserData.UserDisplayName = UserData.firstName + " " + UserData.lastName; 


    var formData = new FormData();
      var formDataOutput = "";
      Object.keys(UserData).forEach((key)=>{
        if(UserData[key] != null){
          formData.append(key,UserData[key]);
          formDataOutput +=  "\n" + key + ":" + UserData[key] ;
          console.log(key, UserData[key]);
        }
      });
      console.log("🚀 > ProductsComponent > Object.keys > formDataOutput:", formDataOutput);
    
    this.UsersService.addUser(formData).subscribe({
      next: (res: any) => {
        console.log(res);
        if (res.isSuccess) {
          const options = {
            title: 'Success',
            delay: 3000,
            color: 'success',
            autohide: true,
            description: res.message,
            status: true,
          };
          this.ToastService.showToast(options);
          
        } else {
          const options = {
            title: 'Failed',
            delay: 3000,
            color: 'danger',
            autohide: true,
            description: res.message,
            status: false,
          };
          this.ToastService.showToast(options);
        }
        this.getUsers();
        this.ButtonLoading = false;
        this.toggleModal();
      },
      error: (error) => {
        console.error(error);
        this.ButtonLoading = false;
        // alert("Error: " + error.error.message);
      },
    });
  }
  
  @ViewChild('ProductDetailsForm') RegisterForm: NgForm | undefined;
  checkUserName(username: string, myForm: NgForm) {
  console.log("🚀 > RegisterComponent > checkUserName > username:", username)
    console.log('Focus OUT');
    this.UsersService.CheckUserName(username).subscribe(
      (response: any) => {
        console.log(response);
        if (!response.isSuccess) {
          this.RegisterForm?.control.get('Email')?.setErrors({ EmailExists: true });
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }


  EditUser(UserData: any) {

    console.log("🚀 > UsersComponent > EditUser > UserData:", UserData)    
    this.toggleModal();
    this.UsersService.UserData = UserData;
    this.EditMode = true;
  }


  updateUser(UserDetailsForm: any, UserData: any) {
    console.log("🚀 > UsersComponent > updateUser > UserData:", UserData);
    this.ButtonLoading = true;
    this.customStylesValidated = true;
    if (UserDetailsForm.invalid) {
      this.ButtonLoading = false;
      return;
    }
    UserData.updatedOnUTC = new Date().toISOString();
    this.UsersService.editUser(UserData).subscribe({
      next: (res: any) => {
        console.log(res);
        this.msg = res;
        setTimeout(() => {
          this.msg = undefined;
        }, 3000);
        this.getUsers();
        this.ButtonLoading = false;
        this.toggleModal();
      },
      error: (error) => {
        console.error(error);
        this.ButtonLoading = false;
        alert("Error: " + error.error.message);
      },
    });

  }

  DeleteUser(item: any) {
    this.UsersService.deleteUser(item.id).subscribe({
      next: (res: any) => {
        console.log(res);
        this.msg = res;
        setTimeout(() => {
          this.msg = undefined;
        }, 3000);
        this.getUsers();
      },
      error: (error) => {
        console.error(error);
        alert("Error: " + error.error.message);
      },
    });
  }

  OpenUserPage(item: any) {
    console.log("🚀 > Openpartnerpage > item:", item.item)
    this.UsersService.selectedPartnerDataUpdate(item.item);
    console.log(this.baseService.USERIMAGESURL + item.item.picture);
    this.router.navigate(['/partnerpage']);
  }
}
